import { render } from "./TheAuth.vue?vue&type=template&id=05351ad8"
import script from "./TheAuth.vue?vue&type=script&lang=js"
export * from "./TheAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__